<script setup>
import AppWell from '../../../../../Shared/AppWell.vue';
import AppCard from '../../../../../Shared/AppCard.vue';
import StudentsProfileStackFiltered from '../../../../../components/StudentsProfileStackFiltered.vue';
import SurveyAnswerCommentsButton from './SurveyAnswerCommentsButton.vue';
import FormLabel from '../../../../../components/Forms/FormLabel.vue';
import FormInput from '../../../../../components/Forms/FormInput.vue';
import { computed, ref } from 'vue';
import deburr from 'lodash/deburr';

const props = defineProps({
    report: {
        type: Object,
        required: true,
    },
    students: {
        type: Array,
        // required: true,
        required: false,
        default: () => [],
    },
});

const showUnanswered = ref(false);
const search = ref('');

const answers = computed(() => {
    const searchValue = deburr(search.value.toLowerCase().trim());
    return props.report.answers
        .filter((a) => {
            if (showUnanswered.value) {
                return true;
            }
            return !a.not_answered;
        })
        .filter((a) => {
            if (searchValue === '') {
                return true;
            }

            if (a.text === null) {
                return false;
            }
            return a.answers.some((textAnswer) => deburr(textAnswer.text.toLowerCase()).includes(searchValue));
        });
});

const unansweredCount = computed(() => {
    return props.report.answers.filter((a) => {
        return a.not_answered;
    }).length;
});
</script>

<template>
    <div class="flex gap-4 items-center" v-if="answers.length > 1">
        <label>
            <input
                type="checkbox"
                :name="`showUnanswered_`"
                v-model="showUnanswered"
                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
            />
            <span class="ml-1"> {{ $t('messages.show_unanswered') }} ({{ unansweredCount }})</span>
        </label>
        <div>
            <FormLabel :value="$t('messages.filter_answers')" />
            <FormInput v-model="search" :placeholder="$t('messages.filter')" />
        </div>
    </div>

    <AppWell class="mt-3">
        <div class="grid grid-cols-4 gap-4">
            <div v-for="userAnswer in answers" :key="userAnswer.id">
                <AppCard>
                    <div class="flex justify-between items-center">
                        <StudentsProfileStackFiltered
                            :students="students"
                            :selected="[userAnswer.user_id]"
                            class="inline-block h-8"
                            key-property="value"
                            name-property="text"
                        />
                        <div class="text-xs">{{ userAnswer.full_name }}</div>
                        <div>
                            <SurveyAnswerCommentsButton
                                :comments="userAnswer.comments"
                                v-if="userAnswer.comments !== null"
                            />
                        </div>
                    </div>
                    <div class="mt-1">
                        <div v-if="userAnswer.not_answered" class="text-gray-500">
                            {{ $t('messages.unanswered') }}
                        </div>
                        <ul v-else class="ml-5 list-disc">
                            <li v-for="answer in userAnswer.answers" :key="answer.id">
                                {{ answer.text }}
                            </li>
                        </ul>
                    </div>
                    <div class="text-gray-600 mt-1 text-xs flex justify-end" v-if="userAnswer.date">
                        {{ userAnswer.date_display }}
                    </div>
                </AppCard>
            </div>
        </div>
    </AppWell>
</template>
